import createItemFetcher from "../helpers/item";
import { createUseFetch, createUseItem } from "../helpers/fetchHooks";
import { createActionDuck } from "../helpers/action";
import { createNotificationsEpic } from "../helpers/notifications";
import { createUseAction } from "../helpers/actionHooks";
const computeScriptsId = () => "focasScripts";
const computeFocasCategoriesUrl = () => "/api/v1/aggregation-service/categories";
const getFocasCategories = createItemFetcher(computeFocasCategoriesUrl, "FOCAS_CATEGORIES_GET", computeScriptsId);
export const useFetchFocasCategories = createUseItem(getFocasCategories, (state) => state.focasScripts.categories);
const computeUpdateFocasCategorieUrl = (category) => ({
    url: `/api/v1/aggregation-service/categories/${category}`,
    method: "PUT",
});
const focasCategoriesUpdateDuck = createActionDuck("FOCAS_CATEGORIES_UPDATE", computeUpdateFocasCategorieUrl, computeScriptsId);
focasCategoriesUpdateDuck.middleware =
    focasCategoriesUpdateDuck.middleware.concat(createNotificationsEpic(focasCategoriesUpdateDuck.ActionKeys, "Script folder updated", () => ""));
export const useUpdateFocasCategorie = createUseAction(focasCategoriesUpdateDuck, (state) => state.focasScripts.updateCat);
const computeFocasScriptUrl = (scriptPath) => `/api/v1/aggregation-service/categories/${scriptPath.category}/scripts/${scriptPath.fileName}`;
const getFocasScript = createItemFetcher(computeFocasScriptUrl, "FOCAS_SCRIPT_GET", computeScriptsId);
export const useFetchFocasScript = createUseFetch(getFocasScript, (state) => state.focasScripts.script);
const computeCreateFocasScriptUrl = (category) => ({
    url: `/api/v1/aggregation-service/categories/${category}/scripts`,
    method: "POST",
});
const focasScriptsCreateDuck = createActionDuck("FOCAS_SCRIPT_CREATE", computeCreateFocasScriptUrl, computeScriptsId);
focasScriptsCreateDuck.middleware = focasScriptsCreateDuck.middleware.concat(createNotificationsEpic(focasScriptsCreateDuck.ActionKeys, "Script created", () => ""));
export const useCreateFocasScript = createUseAction(focasScriptsCreateDuck, (state) => state.focasScripts.createScript);
const computeUpdateFocasScriptUrl = (scriptPath) => ({
    url: `/api/v1/aggregation-service/categories/${scriptPath.category}/scripts/${scriptPath.fileName}`,
    method: "PUT",
});
const focasScriptUpdateDuck = createActionDuck("FOCAS_SCRIPT_UPDATE", computeUpdateFocasScriptUrl, computeScriptsId);
focasScriptUpdateDuck.middleware = focasScriptUpdateDuck.middleware.concat(createNotificationsEpic(focasScriptUpdateDuck.ActionKeys, "Script updated", () => ""));
export const useUpdateFocasScript = createUseAction(focasScriptUpdateDuck, (state) => state.focasScripts.updateScript);
const computeDeleteFocasScriptUrl = (scriptPath) => ({
    url: `/api/v1/aggregation-service/categories/${scriptPath.category}/scripts/${scriptPath.fileName}`,
    method: "DELETE",
});
const focasScriptDeleteDuck = createActionDuck("FOCAS_SCRIPT_DELETE", computeDeleteFocasScriptUrl, computeScriptsId);
focasScriptDeleteDuck.middleware = focasScriptDeleteDuck.middleware.concat(createNotificationsEpic(focasScriptDeleteDuck.ActionKeys, "Script deleted", () => ""));
export const useDeleteFocasScript = createUseAction(focasScriptDeleteDuck, (state) => state.focasScripts.deleteScript);
export function createFocasScriptsActions() {
    const computeGetFocasCategoryUrl = (category) => `/api/v1/aggregation-service/categories/${category}`;
    const getFocasCategory = createItemFetcher(computeGetFocasCategoryUrl, "FOCAS_CATEGORY_GET", computeScriptsId);
    return {
        categories: getFocasCategories,
        categorie: getFocasCategory,
        updateCat: focasCategoriesUpdateDuck,
        createScript: focasScriptsCreateDuck,
        updateScript: focasScriptUpdateDuck,
        deleteScript: focasScriptDeleteDuck,
        script: getFocasScript,
    };
}
//# sourceMappingURL=focasScriptActions.js.map